// extracted by mini-css-extract-plugin
export default {"morePartners":"MorePartners_morePartners__3rhAk","morePartners__inner":"MorePartners_morePartners__inner__W7v7P","morePartners__grid":"MorePartners_morePartners__grid__Ue5hN"};